var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('coverageAndThomaticReport',{attrs:{"type":"program","label":"programs_report"}})}
var staticRenderFns = []

export { render, staticRenderFns }